import { invokeApi } from "../bl_libs/invokeApi";

export const get_companies_api = async (data) => {
  const requestObj = {
    path: `api/company/list`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};



